import axios from 'axios'
import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions'
import * as TYPE from '@/const.types'
import store from '../store'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { 'Cache-Control': 'no-cache', 'X-Consumer-ID': process.env.VUE_APP_API_X_CONSUMER_ID },
  adapter: throttleAdapterEnhancer(cacheAdapterEnhancer(axios.defaults.adapter))
})

const API = {
  // HOME
  HOME: '/api/home/settings?_format=json',

  // META TAG
  META_TAG_MAIN: '/api/metatag/home/home?_format=json',
  META_TAG_PAGE: '/api/metatag/node/:uuid?_format=json',
  META_TAG_SAMPLE: '/api/metatag/sample/:uuid?_format=json',

  // MENU
  MENU: '/api/menus?_format=json',

  // SETTINGS
  SETTINGS: '/api/custom/settings?_format=json',

  // SEARCH
  SEARCH_MSG: '/api/search/no-results?_format=json',

  // ROUTER
  ROUTER: '/router/translate-path?path=:path&_format=json',

  // JOB
  JOB_LIST: '/api/node/job?include=cover_visual,cover_visual.field_image',
  JOB_DETAILS: '/api/node/job/:uuid?include=job_paragraph_content,job_paragraph_content.key_figures,job_paragraph_content.questions,job_paragraph_content.image,job_paragraph_content.markers,job_paragraph_content.samples,job_paragraph_content.samples.sample,job_paragraph_content.samples.sample.photos,job_paragraph_content.samples.sample.photos.field_image,job_paragraph_content.drawers,job_paragraph_content.drawers.drawer,job_paragraph_content.drawers.drawer.media,job_paragraph_content.drawers.drawer.media.field_image,job_paragraph_content.sound,job_paragraph_content.sound.sound,job_paragraph_content.visuals,job_paragraph_content.visuals.visual,job_paragraph_content.visuals.visual.field_image,job_paragraph_content.visual,job_paragraph_content.visual.field_image',

  // COLLECTION
  COLLECTION_LIST: '/api/node/collection?include=collection_type,background,background.field_image',
  COLLECTION_DETAILS: '/api/node/collection/:uuid?include=background,background.field_image,collection_type,key_figures,key_figures.key_figures,paragraph_content,paragraph_content.markers,paragraph_content.visuals,paragraph_content.visuals.visual,paragraph_content.visuals.visual.field_image,paragraph_content.visual,paragraph_content.visual.field_image,discoverer,highlighted_samples&fields[file--file]=url,uri,uri.url&fields[taxonomy_term--collection_type]=name&fields[person--person]=name,firstname,lastname&fields[paragraph--map]=title,markers&fields[paragraph--chapter]=title,paragraph_content&fields[paragraph--key_figure]=title,figure&fields[paragraph--key_figures]=key_figures&fields[paragraph--exergue]=content,visual&fields[paragraph--file]=file,title&fields[paragraph--did_you_know_that]=title,description&fields[paragraph--marker]=marker,title&fields[paragraph--portrait]=description,visual&fields[paragraph--image_text]=description,image&&fields[paragraph--question]=good_answer,explanations,question,responses&fields[paragraph--quizz]=questions,title&fields[paragraph--sound]=sound&fields[paragraph--drawer]=drawer,title&fields[paragraph--drawers]=drawers&fields[paragraph--visual]=visual,title&fields[paragraph--visuals]=visuals&fields[paragraph--wysisyg]=content&fields[paragraph--sample]=title,sample&fields[paragraph--samples]=samples',
  COLLECTION_DRAWERS: '/api/taxonomy_term/drawer?filter[c][condition][path]=collection.id&filter[c][condition][value]=:uuid&fields[file--file]=url&fields[media--image]=name,field_image&include=media,media.field_image&page[offset]=:offset&page[limit]=:limit&sort=row,column,number',

  // DRAWER
  DRAWER_DETAILS: '/api/taxonomy_term/drawer/:uuid?fields[file--file]=url&include=collection,media,media.field_image',
  DRAWER_SAMPLES: '/api/sample/:type?filter[c][condition][path]=drawer.id&filter[c][condition][value]=:uuid&fields[file--file]=url&include=drawer,photos,photos.field_image',
  // /api/sample/mineral/:uuid?fields[file--file]=url&include=drawer,drawer.collection,mineral,mineral.classification,mineral.classification.paragraph_content,photos,photos.field_image
  // SAMPLE
  SAMPLE_DETAILS_MINERAL: '/api/sample/mineral/:uuid?include=iframe,drawer,drawer.collection,drawer.media,drawer.media.field_image,photos,photos.field_image,mineral,mineral.classification,mineral.classification.paragraph_content,mineral.classification.paragraph_content.drawers,mineral.classification.paragraph_content.drawers.drawer,mineral.classification.paragraph_content.drawers.drawer.media,mineral.classification.paragraph_content.drawers.drawer.media.thumbnail,mineral.classification.paragraph_content.file,mineral.classification.paragraph_content.key_figures,mineral.classification.paragraph_content.markers,mineral.classification.paragraph_content.questions,mineral.classification.paragraph_content.samples,mineral.classification.paragraph_content.samples.sample,mineral.classification.paragraph_content.samples.sample.photos,mineral.classification.paragraph_content.samples.sample.photos.field_image,mineral.classification.paragraph_content.sound,mineral.classification.paragraph_content.sound.sound,mineral.classification.paragraph_content.visual,mineral.classification.paragraph_content.visual.field_image,mineral.classification.paragraph_content.visual.photographer,mineral.classification.paragraph_content.visuals,mineral.classification.paragraph_content.visuals.visual,mineral.classification.paragraph_content.visuals.visual.field_image',
  SAMPLE_DETAILS_FOSSIL: '/api/sample/fossil/:uuid?include=iframe,drawer,drawer.collection,drawer.media,drawer.media.field_image,photos,photos.field_image,fossil,fossil.phylogenetic_group,fossil.phylogenetic_group.paragraph_content,fossil.phylogenetic_group.paragraph_content.drawers,fossil.phylogenetic_group.paragraph_content.drawers.drawer,fossil.phylogenetic_group.paragraph_content.drawers.drawer.media,fossil.phylogenetic_group.paragraph_content.drawers.drawer.media.thumbnail,fossil.phylogenetic_group.paragraph_content.file,fossil.phylogenetic_group.paragraph_content.key_figures,fossil.phylogenetic_group.paragraph_content.markers,fossil.phylogenetic_group.paragraph_content.questions,fossil.phylogenetic_group.paragraph_content.samples,fossil.phylogenetic_group.paragraph_content.samples.sample,fossil.phylogenetic_group.paragraph_content.samples.sample.photos,fossil.phylogenetic_group.paragraph_content.samples.sample.photos.field_image,fossil.phylogenetic_group.paragraph_content.sound,fossil.phylogenetic_group.paragraph_content.sound.sound,fossil.phylogenetic_group.paragraph_content.visual,fossil.phylogenetic_group.paragraph_content.visual.field_image,fossil.phylogenetic_group.paragraph_content.visual.photographer,fossil.phylogenetic_group.paragraph_content.visuals,fossil.phylogenetic_group.paragraph_content.visuals.visual,fossil.phylogenetic_group.paragraph_content.visuals.visual.field_image',
  SAMPLE_DETAILS_ROCK: '/api/sample/rock/:uuid?include=iframe,drawer,drawer.collection,drawer.media,drawer.media.field_image,photos,photos.field_image,rock,rock.rock_family,rock.rock_family.paragraph_content,rock.rock_family.paragraph_content.drawers,rock.rock_family.paragraph_content.drawers.drawer,rock.rock_family.paragraph_content.drawers.drawer.media,rock.rock_family.paragraph_content.drawers.drawer.media.thumbnail,rock.rock_family.paragraph_content.file,rock.rock_family.paragraph_content.key_figures,rock.rock_family.paragraph_content.markers,rock.rock_family.paragraph_content.questions,rock.rock_family.paragraph_content.samples,rock.rock_family.paragraph_content.samples.sample,rock.rock_family.paragraph_content.samples.sample.photos,rock.rock_family.paragraph_content.samples.sample.photos.field_image,rock.rock_family.paragraph_content.sound,rock.rock_family.paragraph_content.sound.sound,rock.rock_family.paragraph_content.visual,rock.rock_family.paragraph_content.visual.field_image,rock.rock_family.paragraph_content.visual.photographer,rock.rock_family.paragraph_content.visuals,rock.rock_family.paragraph_content.visuals.visual,rock.rock_family.paragraph_content.visuals.visual.field_image',
  SAMPLE_DETAILS_ORE: '/api/sample/ore/:uuid?include=iframe,drawer,drawer.collection,drawer.media,drawer.media.field_image,photos,photos.field_image,ore,ore.ore_family,ore.ore_family.paragraph_content,ore.ore_family.paragraph_content.drawers,ore.ore_family.paragraph_content.drawers.drawer,ore.ore_family.paragraph_content.drawers.drawer.media,ore.ore_family.paragraph_content.drawers.drawer.media.thumbnail,ore.ore_family.paragraph_content.file,ore.ore_family.paragraph_content.key_figures,ore.ore_family.paragraph_content.markers,ore.ore_family.paragraph_content.questions,ore.ore_family.paragraph_content.samples,ore.ore_family.paragraph_content.samples.sample,ore.ore_family.paragraph_content.samples.sample.photos,ore.ore_family.paragraph_content.samples.sample.photos.field_image,ore.ore_family.paragraph_content.sound,ore.ore_family.paragraph_content.sound.sound,ore.ore_family.paragraph_content.visual,ore.ore_family.paragraph_content.visual.field_image,ore.ore_family.paragraph_content.visual.photographer,ore.ore_family.paragraph_content.visuals,ore.ore_family.paragraph_content.visuals.visual,ore.ore_family.paragraph_content.visuals.visual.field_image',

  // TOUR
  TOUR: '/api/node/tour',
  TOUR_LIST: '/api/node/tour?fields[file--file]=url&include=tour_type,cover_visual,cover_visual.field_image',
  TOUR_DETAILS: '/api/node/tour/:uuid?fields[file--file]=url&include=tour_type,chapters,chapters.paragraph_content,chapters.paragraph_content.key_figures,chapters.paragraph_content.questions,chapters.paragraph_content.image,chapters.paragraph_content.markers,chapters.paragraph_content.samples,chapters.paragraph_content.samples.sample,chapters.paragraph_content.samples.sample.photos,chapters.paragraph_content.samples.sample.photos.field_image,chapters.paragraph_content.drawers,chapters.paragraph_content.drawers.drawer,chapters.paragraph_content.drawers.drawer.media,chapters.paragraph_content.drawers.drawer.media.field_image,chapters.paragraph_content.sound,chapters.paragraph_content.sound.sound,chapters.paragraph_content.visuals,chapters.paragraph_content.visuals.visual,chapters.paragraph_content.visuals.visual.field_image,chapters.paragraph_content.visual,chapters.paragraph_content.visual.field_image,cover_visual,cover_visual.field_image,cover_visual.field_image',
  TOUR_CHAPTERS: '/api/node/tour/:uuid/chapters',

  // PAGE
  PAGE: '/api/node/page/:uuid',
  PAGE_LIST: '/api/node/page',
}

function url (locale, path, ...segments) {
  let i = 0
  const { state } = store
  const uri = path.replace(/:\w+/g, () => {
    let s = segments[i]
    i += 1
    return s
  })

  return locale + uri
}

export default {
  install (Vue, options) {
    const $api = {
      getHome (locale) {
        return http.get(url(locale, API.HOME))
      },
      getMainMetaTag (locale) {
        return http.get(url(locale, API.META_TAG_MAIN))
      },
      getPageMetaTag (locale, uuid) {
        return http.get(url(locale, API.META_TAG_PAGE, uuid))
      },
      getSampleMetaTag (locale, uuid) {
        return http.get(url(locale, API.META_TAG_SAMPLE, uuid))
      },
      getSettings (locale) {
        return http.get(url(locale, API.SETTINGS))
      },
      getEntityByPath (locale, path) {
        return http.get(url(locale, API.ROUTER, path))
      },
      entityGuard (locale, to, from, next) {
        Vue.$api.getEntityByPath(locale, to.path)
          .then((response) => {
            const entity = response.data.entity

            if (!entity) {
              next({ name: '404' })
              return false
            }

            to.params.uuid = entity.uuid

            next()
          })
      },
      getMenu (locale) {
        return http.get(url(locale, API.MENU))
      },
      getSearchMsg (locale) {
        return http.get(url(locale, API.SEARCH_MSG))
      },
      getJobs (locale) {
        return http.get(url(locale, API.JOB_LIST))
      },
      getJob (locale, uuid) {
        return http.get(url(locale, API.JOB_DETAILS, uuid))
      },
      getCollections (locale) {
        return http.get(url(locale, API.COLLECTION_LIST))
      },
      getCollection (locale, uuid) {
        return http.get(url(locale, API.COLLECTION_DETAILS, uuid))
      },
      getCollectionDrawers (locale, uuid, offset = 0, limit = 10) {
        return http.get(url(locale, API.COLLECTION_DRAWERS, uuid, offset, limit))
      },
      getDrawer (locale, uuid) {
        return http.get(url(locale, API.DRAWER_DETAILS, uuid))
      },
      getDrawerSamples (locale, type, uuid) {
        return http.get(url(locale, API.DRAWER_SAMPLES, type, uuid))
      },
      getSample (locale, type, uuid) {
        const geologicTypes = new Map([
          [TYPE.SAMPLE_MINERAL, API.SAMPLE_DETAILS_MINERAL],
          [TYPE.SAMPLE_FOSSIL, API.SAMPLE_DETAILS_FOSSIL],
          [TYPE.SAMPLE_ORE, API.SAMPLE_DETAILS_ORE],
          [TYPE.SAMPLE_ROCK, API.SAMPLE_DETAILS_ROCK]
        ])

        return http.get(url(locale, geologicTypes.get(type), uuid))
      },
      getTours (locale) {
        return http.get(url(locale, API.TOUR_LIST))
      },
      getTour (locale, uuid) {
        return http.get(url(locale, API.TOUR_DETAILS, uuid))
      },
      getTourChapters (locale, uuid) {
        return http.get(url(locale, API.TOUR_CHAPTERS, uuid))
      },
      getPages (locale) {
        return http.get(url(locale, API.PAGE_LIST))
      },
      getPage (locale, uuid) {
        return http.get(url(locale, API.PAGE, uuid))
      },
      get (url) {
        return http.get(url)
      }
    }

    Vue.prototype.$api = $api
    Vue.$api = $api
  }
}
